import { Link } from 'react-router-dom'
import { useLocale } from '../App'

export function MarketplacePage() {
  const { content: c } = useLocale()
  const getStr = (key: string, def: string) => ((c as Record<string, unknown>)[key] as string | undefined) ?? def
  const pageTitle = getStr('marketplacePageTitle', '马匹市场')
  const pageSubtitle = getStr('marketplacePageSubtitle', '发现优质赛马资产，开启您的投资之旅')
  const breadcrumbHome = getStr('breadcrumbHome', '首页')
  const comingSoon = (c as { comingSoon?: string }).comingSoon ?? 'Coming Soon'

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">{pageTitle}</h1>
            <p className="page-subtitle">{pageSubtitle}</p>
            <div className="breadcrumb">
              <Link to="/">{breadcrumbHome}</Link>
              <i className="fas fa-chevron-right"></i>
              <span>{pageTitle}</span>
            </div>
          </div>
        </div>
      </section>

      <section className="marketplace marketplace-coming-soon">
        <div className="container">
          <div className="featured-coming-soon">
            <i className="fas fa-clock"></i>
            <p className="featured-coming-soon-text">{comingSoon}</p>
          </div>
        </div>
      </section>
    </>
  )
}
